<script>
const moneyFormat = function (price) {
  const pieces = parseFloat(price).toFixed(2).split('')
  let ii = pieces.length - 3
  while ((ii -= 3) > 0) {
    pieces.splice(ii, 0, ',')
  }
  return pieces.join('')
}
/* truncando decimales */
const toDecimal = function (num, decimales) {
  num = num.toString() // If it's not already a String
  console.log({ num })
  num = num.slice(0, (num.indexOf('.')) + decimales + 1) // With 3 exposing the hundredths place
  console.log({ num })

  const pieces = parseFloat(num).toFixed(decimales).split('')
  let ii = pieces.length - decimales - 1
  while ((ii -= 3) > 0) {
    pieces.splice(ii, 0, ',')
  }
  return pieces.join('')
}
const _toDecimal = function (num, decimales) {
  let resul = ''
  let decimal
  const split = (num / Math.pow(10, decimales)).toString().split('.')
  // entero
  const entero = split[0].split('')
  let ii = entero.length
  while ((ii -= 3) > 0) {
    entero.splice(ii, 0, ',')
  }
  resul = entero.join('')
  // decimal
  if (split[1] !== undefined) {
    resul += '.'
    decimal = split[1].split('')
    let i = decimal.length - 1
    while (i >= 1) {
      if (decimal[i] !== '0') break
      i--
    }
    let j = 0
    while (j <= i) {
      resul += decimal[j++]
    }
  }
  return resul
}
const timeStr = function (timestamp) {
  console.log({ timestamp })
  const sec = 1
  const min = 60 * sec
  const hours = min * 60
  const days = hours * 24
  let value = 0
  let group = ''
  timestamp = timestamp > 0 ? timestamp : 0
  if (timestamp > days) {
    value = timestamp / days
    group = 'Days'
  } else {
    if (timestamp > hours) {
      value = timestamp / hours
      group = 'Hours'
    } else {
      if (timestamp > min) {
        value = timestamp / min
        group = 'Min'
      } else {
        value = timestamp
        group = 'Sec'
      }
    }
  }
  return Math.trunc(value) + ' ' + group
}

const formatter = function (value, max) {
  const split = value.toString().split('.')
  if (split.length === 2) {
    if (split[1].length > max) {
      const temp = split[0] + '.' + split[1].substring(0, max)
      return temp
    }
  }
  return value
}
export default {
  moneyFormat,
  toDecimal,
  _toDecimal,
  timeStr,
  formatter
}
</script>
